import { Link } from "react-router-dom";
import { EmptyState } from "@cloudox/ui";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export function NotFoundPage() {
  useDocumentTitle("Page not found");
  return (
    <EmptyState
      headingLevel={1}
      title="Page not found"
      description="The page you requested does not exist. It may have been moved or the URL is incorrect."
      action={
        <Link to="/" className="btn btn-primary">
          Back to the overview
        </Link>
      }
    />
  );
}
